<template>
	<div id="main">
		<div class="bg-other user-head-info">
			<div class="user-info clearfix">
				<div class="user-pic" data-is-fans="0" data-is-follows="">
					<div class="user-pic-bg">
						<img class="img" :src="this.$store.state.sessionInfo.headimgurl" alt="">
					</div>
				</div>
				<div class="user-info-right">
					<h3 class="user-name clearfix">
						<span>{{this.$store.state.sessionInfo.wxNickName}}</span>
						</h3>
					<p class="about-info">
						<span>{{this.$store.state.sessionInfo.roleInfo.roleName}}</span>
					</p>
				</div>
				<div class="study-info clearfix">
					<div class="item follows">
						<div class="u-info-learn" title="学习时长28时11分" style="cursor:pointer;">
							<em>0</em>
							<span>直播时长 </span>
						</div>
					</div>
					<div class="item follows">
						<a href="#"><em>0</em></a>
						<span>直播次数</span>
					</div>
					<div class="item follows">
						<a href="#"><em>1</em></a>
						<span>班级</span>
					</div>
					<div class="item follows">
						<a href="#"><em>10</em></a>
						<span>学生</span>
					</div>
				</div>
			</div>
		</div>
		<div class="wrap">
			<div class="slider">
				<ul>
					<li v-for="(item,key) of classList" :key="item.id">
						<a href="javascript:void(0)" :class="{active:item.id==cid}" v-on:click="qh(item.id,item.className)">
							<span>{{item.className}}</span><b class="icon-drop_right"></b>
						</a>
					</li>
					<li>
						<div class="tc-label">
							<img :src="teacherInfo.headimgurl" class="rounded" />
							<p>{{teacherInfo.userDesc}}</p>
						</div>
					</li>
				</ul>
			</div>
			<div class="u-container">
				<div class="nav">
					<div class="left-nav">
						<span class="title active">{{cname}}<span class="t1">|</span>
						<a href="javascript:void(0)" @click="tolive"><span class="t2"><i class="fa fa-users"></i>开启班级直播间</span></a>
						</span>
					</div>
				</div>
				<div class="course-floor clearfix">
					<div class="card" v-for="(item,key) of userList" :key="item.id">
						<div href="javascript:void(0)" class="card-course is-auth">
							<div class="card-course-top hashadow"><img :src="item.userInfo.headimgurl" class="course-banner"></div>
							<div class="course-card-content">
								<h3 class="course-card-name">{{item.userInfo.wxNickName}}</h3>
								<div class="link">
									<a class="btn btn btn-primary btn1" href="javascript:void(0)" @click="torobot(item.userInfo.id)"><i class="fa fa-search" aria-hidden="true"></i> 机器人编程</a>
									<a class="btn btn-success btn2" href="javascript:void(0)" @click="totuxing(item.userInfo.id)"><i class="fa fa-search" aria-hidden="true"></i> 图形化编程</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'TeachScenterContent',
		data() {
			return {
				classList: [],
				userList: [],
				cid: null,
				cname: null,
				teacherInfo: null
			}
		},
		methods: {
			torobot(uid) {
				var ustr = 'u' + uid + "/mcode/"
				window.open("https://itmsw.cn/course/m-coding.html?userFileRoot=" + ustr)
			},
			totuxing(uid) {
				var ustr = 'u' + uid + "/mcode/"
				window.open("https://itmsw.cn/course/v-coding.html?userFileRoot=" + ustr)
			},
			qh(cid, cname) {
				this.cid = cid
				this.cname = cname
				this.queryByClassId(this.cid)
			},
			queryByClassId(cid) {
				axios.get('/itmswcn/userClass/class/query/' + cid)
					.then(this.queryByClassIdSucc)
			},
			queryByClassIdSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.userList = data
					this.teacherInfo = this.userList[0].classInfo.teacherInfo
				}
			},
			tolive() {
				axios.get('/itmswcn/maintain/classLive/openRoom/' + this.cid)
					.then(this.getOpenRoomSucc)
			},
			getOpenRoomSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					window.open("https://itmsw.cn/live/live.html?cid=" + data.classId + "&rid=" + data.roomId + "&rstr=" + data.randStr)
				}
			},
			tochart() {
				window.open("https://itmsw.cn/chart/home.html")
			},
			getDataInfo() {
				axios.get('/itmswcn/maintain/classInfo/queryList')
					.then(this.getDataInfoSucc)
			},
			getDataInfoSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.classList = data
					this.cid = data[0].id
					this.cname = data[0].className
					this.queryByClassId(this.cid)
				}
			}
		},
		mounted() {
			this.getDataInfo()
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/teach/components/TeachCenterContent.scss';
</style>